import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {BaseStoreService} from '@app/services/base-store.service';
import {first, map} from 'rxjs/operators';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {LAUNCH_CALLER, LaunchDialogService} from '@spartacus/storefront';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class CcRestrictedCountryGuard  {

  constructor(
    private baseStoreService: BaseStoreService,
    private router: Router,
    private launchDialogService: LaunchDialogService,
  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.baseStoreService.getCurrentBaseStore().pipe(
      first(),
      map(baseStore => {
        if (this.baseStoreService.isCcAllowedForCountry(baseStore)) {
          return true;
        } else {
          this.launchDialogService.openDialogAndSubscribe(LAUNCH_CALLER.CC_RESTRICTED);
          return this.router.parseUrl('/selectionType');
        }
      }),
      untilDestroyed(this)
    );
  }
}
